import ShowItemContent from "./ShowItemContent"

const TextField = ({ item, isGroupNote }) => {
  return (<>
    {item.content?.trim() ?
      <div className="">
        <p className='text' style={{ whiteSpace: "pre-line" }}>{ShowItemContent(item, isGroupNote)}</p>
      </div> : <></>}
  </>
  )
}

export default TextField